import React, { useState } from 'react';

const Eighththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: High Voltage */
            --bg-dark: #0a0a0a;
            --bg-panel: #141414;
            --text-main: #e0e0e0;
            --text-muted: #888888;
            --accent: #ccff00;
            /* Neon Lime */
            --accent-glow: rgba(204, 255, 0, 0.4);
            --white: #ffffff;

            --font-display: 'Teko', sans-serif;
            --font-head: 'Oswald', sans-serif;
            --font-body: 'Roboto', sans-serif;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            background-color: var(--bg-dark);
            color: var(--text-main);
            line-height: 1.6;
            overflow-x: hidden;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            font-family: var(--font-head);
            text-transform: uppercase;
            line-height: 1.1;
            color: var(--white);
        }

        h1 {
            font-family: var(--font-display);
            letter-spacing: 2px;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .section {
            padding: 100px 0;
            position: relative;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 18px 40px;
            background: transparent;
            color: var(--accent);
            border: 2px solid var(--accent);
            font-family: var(--font-head);
            font-size: 1.1rem;
            font-weight: 700;
            text-transform: uppercase;
            cursor: pointer;
            letter-spacing: 1px;
            position: relative;
            overflow: hidden;
            z-index: 1;
            clip-path: polygon(15px 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%, 0 15px);
            transition: 0.3s;
        }

        .btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 0;
            height: 100%;
            background: var(--accent);
            z-index: -1;
            transition: 0.3s;
        }

        .btn:hover {
            color: var(--bg-dark);
            text-shadow: none;
            box-shadow: 0 0 20px var(--accent-glow);
        }

        .btn:hover::before {
            width: 100%;
        }

        .btn-filled {
            background: var(--accent);
            color: var(--bg-dark);
        }

        .btn-filled::before {
            background: var(--white);
        }

        /* Top Bar */
        .top-bar {
            background: #000;
            padding: 12px 0;
            border-bottom: 1px solid #222;
            font-size: 0.9rem;
            font-family: var(--font-head);
            letter-spacing: 1px;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .top-info span {
            margin-right: 25px;
            color: var(--text-muted);
        }

        .top-info span svg {
            color: var(--accent);
            margin-right: 5px;
            vertical-align: middle;
            width: 16px;
        }

        /* Nav */
        nav {
            padding: 25px 0;
            position: absolute;
            width: 100%;
            z-index: 100;
            background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent);
        }

        nav .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-family: var(--font-display);
            font-size: 2.5rem;
            font-weight: 700;
            color: var(--white);
            line-height: 1;
        }

        .brand span {
            color: var(--accent);
        }

        .nav-menu {
            display: flex;
            gap: 30px;
            list-style: none;
            font-family: var(--font-head);
            text-transform: uppercase;
            font-weight: 500;
            font-size: 1rem;
        }

        .nav-menu a:hover {
            color: var(--accent);
        }

        /* Hero */
        .hero {
            height: 100vh;
            background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') center/cover;
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .hero-content {
            max-width: 800px;
            padding-left: 20px;
            border-left: 5px solid var(--accent);
        }

        .hero h1 {
            font-size: 6rem;
            line-height: 0.9;
            margin-bottom: 20px;
            text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
        }

        .hero p {
            font-size: 1.5rem;
            margin-bottom: 40px;
            color: var(--white);
            font-weight: 300;
        }

        /* About */
        .about-section {
            background-color: var(--bg-dark);
            overflow: hidden;
        }

        .section-header {
            margin-bottom: 60px;
        }

        .section-header span {
            color: var(--accent);
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 1.1rem;
            display: block;
            margin-bottom: 10px;
        }

        .section-header h2 {
            font-size: 4rem;
            color: var(--white);
            position: relative;
            display: inline-block;
        }

        .about-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 80px;
            align-items: center;
        }

        .about-text p {
            color: var(--text-muted);
            font-size: 1.1rem;
            margin-bottom: 25px;
        }

        .stats-row {
            display: flex;
            gap: 50px;
            margin-top: 40px;
        }

        .stat h3 {
            font-size: 3rem;
            color: var(--white);
            line-height: 1;
        }

        .stat p {
            font-size: 0.9rem;
            color: var(--accent);
            text-transform: uppercase;
            font-weight: 700;
            margin: 0;
            letter-spacing: 1px;
        }

        .about-img {
            position: relative;
        }

        .about-img img {
            width: 100%;
            display: block;
            clip-path: polygon(10% 0, 100% 0, 100% 90%, 90% 100%, 0 100%, 0 10%);
        }

        .about-img::after {
            content: '';
            position: absolute;
            inset: 0;
            border: 2px solid var(--accent);
            transform: translate(20px, 20px);
            z-index: -1;
            clip-path: polygon(10% 0, 100% 0, 100% 90%, 90% 100%, 0 100%, 0 10%);
        }

        /* Services / Classes */
        .services-section {
            background-color: var(--bg-panel);
        }

        .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .service-card {
            position: relative;
            height: 500px;
            overflow: hidden;
            group: cursor-pointer;
        }

        .service-card img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
            filter: grayscale(100%);
        }

        .service-card:hover img {
            filter: grayscale(0%);
            transform: scale(1.1);
        }

        .service-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 30px;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.95), transparent);
            z-index: 2;
        }

        .service-num {
            font-size: 4rem;
            color: transparent;
            -webkit-text-stroke: 1px var(--white);
            opacity: 0.3;
            font-family: var(--font-display);
            line-height: 0.8;
            position: absolute;
            top: -40px;
            right: 20px;
        }

        .service-card h3 {
            font-size: 2.5rem;
            margin-bottom: 10px;
            transform: skewX(-5deg);
        }

        .service-card p {
            color: var(--text-muted);
            margin-bottom: 20px;
            opacity: 0;
            transform: translateY(20px);
            transition: 0.3s;
        }

        .service-card:hover p {
            opacity: 1;
            transform: translateY(0);
        }

        .arrow-link {
            color: var(--accent);
            font-weight: 700;
            text-transform: uppercase;
            font-family: var(--font-head);
        }

        /* Gallery */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
        }

        .gallery-item {
            position: relative;
            height: 300px;
            overflow: hidden;
            cursor: pointer;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
        }

        .gallery-item:hover img {
            transform: scale(1.05) rotate(2deg);
            opacity: 0.6;
        }

        .gallery-item::before {
            content: '+';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 3rem;
            color: var(--accent);
            opacity: 0;
            transition: 0.3s;
            z-index: 2;
        }

        .gallery-item:hover::before {
            opacity: 1;
        }

        /* Testimonials */
        .testimonial-section {
            background-color: var(--bg-panel);
            background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231a1a1a' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }

        .review-card {
            background: rgba(255, 255, 255, 0.05);
            padding: 40px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            position: relative;
        }

        .review-card::before {
            content: '"';
            font-family: var(--font-display);
            font-size: 6rem;
            color: var(--accent);
            opacity: 0.2;
            position: absolute;
            top: 0;
            left: 20px;
            line-height: 1;
        }

        .review-text {
            font-size: 1.2rem;
            font-style: italic;
            margin-bottom: 25px;
            position: relative;
            z-index: 1;
        }

        .reviewer {
            display: flex;
            align-items: center;
            gap: 15px;
        }

        .reviewer img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: 2px solid var(--accent);
        }

        .reviewer-info h4 {
            font-size: 1.1rem;
            margin-bottom: 2px;
            color: var(--white);
        }

        .reviewer-info small {
            color: var(--accent);
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: 700;
        }

        /* Footer */
        footer {
            background: #000;
            padding: 80px 0 30px;
            border-top: 1px solid #222;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 1.5fr 1fr 1fr 1fr;
            gap: 50px;
            margin-bottom: 50px;
        }

        .footer-brand {
            font-family: var(--font-display);
            font-size: 2rem;
            color: var(--white);
            margin-bottom: 20px;
            display: inline-block;
        }

        .footer-brand span {
            color: var(--accent);
        }

        .footer-widget h4 {
            margin-bottom: 25px;
            font-size: 1.2rem;
        }

        .footer-links li {
            list-style: none;
            margin-bottom: 12px;
        }

        .footer-links a {
            color: var(--text-muted);
            font-size: 0.95rem;
        }

        .footer-links a:hover {
            color: var(--accent);
            padding-left: 5px;
        }

        .footer-bottom {
            border-top: 1px solid #1a1a1a;
            padding-top: 20px;
            text-align: center;
            color: #555;
            font-size: 0.85rem;
        }

        /* Responsive */
        @media (max-width: 900px) {
            .hero h1 {
                font-size: 4rem;
            }

            .about-grid {
                grid-template-columns: 1fr;
            }

            .services-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .gallery-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .footer-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (max-width: 600px) {
            .top-bar {
                display: none;
            }

            .nav-menu {
                display: none;
            }

            .hero h1 {
                font-size: 3rem;
            }

            .services-grid {
                grid-template-columns: 1fr;
            }

            .stats-row {
                flex-wrap: wrap;
            }

            .footer-grid {
                grid-template-columns: 1fr;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500;600;700&family=Roboto:wght@400;500;700&family=Teko:wght@400;500;600;700&display=swap"
                rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="top-info">
                        {get_data.mobile && (
                            <span>
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                {get_data.mobile}
                            </span>
                        )}
                        {get_data.email && (
                            <span>
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                {get_data.email}
                            </span>
                        )}
                        {get_data.business_location_name && (
                            <span>
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd"
                                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                        clipRule="evenodd" />
                                </svg>
                                {get_data.business_location_name}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Nav */}
            <nav>
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <ul className="nav-menu">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">Philosophy</a></li>
                        <li><a href="#classes">Programs</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#reviews">Stories</a></li>
                        <li><a href="#contact" style={{color: 'var(--accent)'}}>Join Now</a></li>
                    </ul>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>FORGE YOUR<br /><span style={{color: 'var(--accent)'}}>ULTIMATE PHYSIQUE</span></h1>
                        <p>Push your limits in a world-class facility designed for serious athletes. No excuses, just results.
                        </p>
                        <a href="#contact" className="btn btn-filled">Get 7-Day Free Pass</a>
                        <a href="#classes" className="btn" style={{marginLeft: '20px'}}>View Programs</a>
                    </div>
                </div>
            </header>

            {/* About */}
            <section className="section about-section" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div className="about-img">
                            <img src="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                                alt="Gym Interior" />
                        </div>
                        <div className="about-text">
                            <div className="section-header">
                                <span>The Philosophy</span>
                                <h2>BUILT ON SWEAT,<br />POWERED BY IRON.</h2>
                            </div>
                            <p>IronForge isn't just a gym; it's a sanctuary for those who refuse to settle for average. We
                                provide the highest quality equipment, expert coaching, and an atmosphere that demands your best
                                effort.</p>
                            <p>Whether you're training for a competition or just fighting to be better than yesterday, you
                                belong here.</p>

                            <div className="stats-row">
                                <div className="stat">
                                    <h3>24/7</h3>
                                    <p>Access</p>
                                </div>
                                <div className="stat">
                                    <h3>50+</h3>
                                    <p>Trainers</p>
                                </div>
                                <div className="stat">
                                    <h3>10K</h3>
                                    <p>Sq. Ft.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Classes/Services */}
            <section className="section services-section" id="classes">
                <div className="container">
                    <div className="section-header" style={{textAlign: 'center'}}>
                        <span>Training Programs</span>
                        <h2>CHOOSE YOUR BATTLE</h2>
                    </div>

                    <div className="services-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="service-card" key={index}>
                                <img 
                                    src={item.icon && item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                    alt={item.name} 
                                />
                                <div className="service-overlay">
                                    <div className="service-num">{String(index + 1).padStart(2, '0')}</div>
                                    <h3>{item.name}</h3>
                                    <p>{item.description || 'Professional training program.'}</p>
                                    <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                                         <a href={`tel:${get_data.mobile}`} className="btn" style={{padding: '10px 20px', fontSize: '0.9rem'}}>Call</a>
                                         <a href="#contact" className="btn" style={{padding: '10px 20px', fontSize: '0.9rem'}}>Enquiry</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products */}
            <section className="section services-section" id="products" style={{backgroundColor: '#000'}}>
                <div className="container">
                    <div className="section-header" style={{textAlign: 'center'}}>
                        <span>Featured Gear</span>
                        <h2>EQUIP YOURSELF</h2>
                    </div>

                    <div className="services-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="service-card" key={index} style={{border: '1px solid #222'}}>
                                <img 
                                    src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`}
                                    alt={item.service_name} 
                                />
                                <div className="service-overlay" style={{padding: '20px'}}>
                                    <h3 style={{fontSize: '1.8rem', marginBottom: '5px'}}>{item.service_name}</h3>
                                    {item.price && <p style={{color: 'var(--accent)', fontWeight: 'bold', fontSize: '1.2rem', margin: '0 0 10px 0', opacity: 1, transform: 'none'}}>₹{item.price}</p>}
                                    <p style={{fontSize: '0.9rem', marginBottom: '15px'}}>{item.description || 'Premium fitness gear.'}</p>
                                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px'}}>
                                         <button onClick={() => addToCart(item)} className="btn btn-filled" style={{padding: '10px', fontSize: '0.8rem', textAlign: 'center'}}>Order</button>
                                         <a href={`tel:${get_data.mobile}`} className="btn" style={{padding: '10px', fontSize: '0.8rem', textAlign: 'center'}}>Call</a>
                                    </div>
                                    <a href="#contact" className="btn" style={{width: '100%', marginTop: '10px', padding: '10px', fontSize: '0.8rem', textAlign: 'center', display: 'block'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Testimonials */}
            <section className="section testimonial-section" id="reviews">
                <div className="container">
                    <div className="section-header">
                        <span>Success Stories</span>
                        <h2>FORGED IN IRON</h2>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px'}}>
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                    <div>
                                        {review.rating && (
                                            <div style={{color: 'var(--accent)', fontSize: '1.2rem', marginBottom: '15px'}}>
                                                {'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}
                                            </div>
                                        )}
                                        <p className="review-text">"{review.review || 'No review data.'}"</p>
                                        <div className="reviewer">
                                            <div>
                                                <h4 style={{color: '#fff', fontSize: '1.2rem'}}>{review.user_name || 'Gym Member'}</h4>
                                                <small style={{color: 'var(--accent)', textTransform: 'uppercase', fontWeight: 600}}>Verified Athlete</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                         <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-muted)', fontStyle: 'italic'}}>
                            <p>No reviews yet.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-widget">
                            <a href="#" className="footer-brand">{get_data.service_name}</a>
                            <p style={{color: '#666'}}>We are dedicated to helping you achieve your goals with expert guidance and premium facilities.</p>
                        </div>
                        <div className="footer-widget" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            <h4>Connect</h4>
                            {get_data.instagram && <a href={get_data.instagram} style={{color: '#888', textDecoration: 'none'}}>Instagram</a>}
                            {get_data.facebook && <a href={get_data.facebook} style={{color: '#888', textDecoration: 'none'}}>Facebook</a>}
                            {get_data.youtube && <a href={get_data.youtube} style={{color: '#888', textDecoration: 'none'}}>Youtube</a>}
                            {get_data.twitter && <a href={get_data.twitter} style={{color: '#888', textDecoration: 'none'}}>Twitter</a>}
                        </div>
                        <div className="footer-widget">
                            <h4>Explore</h4>
                            <ul className="footer-links">
                                <li><a href="#classes">Programs</a></li>
                                <li><a href="#products">Products</a></li>
                                <li><a href="#reviews">Reviews</a></li>
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <h4>Contact</h4>
                            <ul className="footer-links">
                                <li>{get_data.business_location_name}</li>
                                <li>{get_data.mobile}</li>
                                <li>{get_data.email}</li>
                                <li style={{color: 'var(--accent)', marginTop: '10px'}}>Join Us Today</li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        &copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Store'}. All Rights Reserved. Train Hard.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Eighththeme
